import { lazy } from 'react'
import PredictedOrderLoader from './predicted-order/loader'
import AddPurchaseOrdersLoader from './purchase-orders/add/loader'
import EditPurchaseOrdersLoader from './purchase-orders/edit/loader'
import OutstandingOrdersLoader from './purchase-orders/loader'
import OrderTemplatesLoader from './order-templates/loader'
import EditOrderTemplateLoader from './order-templates/edit/loader'
import OrderHistoryLoader from './order-history/loader'

export default {
  OutstandingOrders: {
    Component: lazy(() => import('./purchase-orders/OutstandingOrders.Page')),
    Loader: OutstandingOrdersLoader,
  },
  PredictedOrder: {
    Component: lazy(() => import('./predicted-order/PredictedOrder.Page')),
    Loader: PredictedOrderLoader,
  },
  AddPurchaseOrder: {
    Component: lazy(
      () =>
        import('./purchase-orders/add/purchase-order/AddPurchaseOrders.Page')
    ),
    Loader: AddPurchaseOrdersLoader,
  },
  AddCreditRequest: {
    Component: lazy(
      () => import('./purchase-orders/add/credit-request/AddCreditRequest.Page')
    ),
    Loader: AddPurchaseOrdersLoader,
  },
  EditPurchaseOrder: {
    Component: lazy(
      () => import('./purchase-orders/edit/EditPurchaseOrder.Page')
    ),
    Loader: EditPurchaseOrdersLoader,
  },
  OrderHistory: {
    Component: lazy(() => import('./order-history/OrderHistory.Page')),
    Loader: OrderHistoryLoader,
  },
  OrderTemplates: {
    Component: lazy(() => import('./order-templates/OrderTemplates.Page')),
    Loader: OrderTemplatesLoader,
  },
  EditOrderTemplate: {
    Component: lazy(
      () => import('./order-templates/edit/EditOrderTemplate.Page')
    ),
    Loader: EditOrderTemplateLoader,
  },
}
